<template>
  <div class="col-12 form-group form-group-sm">
    <label class="label" for="vendedor">Vendedor</label>
    <multiselect-item
      id="vendedor"
      v-model="vendedor"
      :custom-label="label"
      :options="vendedorOptions"
      placeholder="Seleccione vendedor"
      track-by="id"
      :loading="isLoading"
    ></multiselect-item>
  </div>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "SelectVendedor",
  beforeMount() {
    this.getVendedores();
  },
  data: () => ({
    vendedorOptions: [],
    isLoading: true,
  }),
  methods: {
    label(vendedor) {
      return vendedor.nombre;
    },
    async getVendedores() {
      this.isLoading = true;
      const { data } = await axios.post("/execute", {
        method: "CLI.GetVendedores",
        parameters: [],
      });
      if (data.ok) {
        this.vendedorOptions = get(data, "result[0]", []);
      } else {
        this.$msgBoxOk(data.message);
      }
      this.isLoading = false;
    },
  },
  computed: {
    vendedor: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.vendedor;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setVendedor", val);
      },
    },
  },
};
</script>
